import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitReview = (rating, comment, audience, recaptcha_token) =>
  axios.post(`${API}/reviews`, { rating, comment, audience, recaptcha_token });

export const AUDIENCES = [
  { id: "artsen", label: "De artsen", img: "/audience/artsen.jpg" },
  { id: "psychiaters", label: "De psychiaters", img: "/audience/psychiaters.jpg" },
  { id: "begeleiders", label: "De begeleiders", img: "/audience/begeleiders.jpg" },
  { id: "mot", label: "Het MOT", sub: "Middelen outreach team", img: "/audience/mot.jpg" },
  { id: "emotiegroep", label: "De emotiegroep", img: "/audience/emotiegroep.jpg" },
  { id: "middelengroep", label: "De middelengroep", img: "/audience/middelengroep.jpg" },
  { id: "sportzaal", label: "De sportzaal", img: "/audience/sportzaal.jpg" },
  { id: "roads", label: "Roads", sub: "Dagbestedings\u00adcoördinatoren", img: "/audience/roads.jpg" },
  { id: "weerbaarheid", label: "Weerbaarheids\u00adtraining", img: "/audience/weerbaarheid.jpg" },
  { id: "keuken", label: "De keuken", img: "/audience/keuken.jpg" },
];
export const unlockReviews = (code) => axios.post(`${API}/reviews/unlock`, { code });

export const EMOJIS = [
  { e: "🤬", label: "Vreselijk" },
  { e: "😡", label: "Heel slecht" },
  { e: "😞", label: "Slecht" },
  { e: "😕", label: "Matig" },
  { e: "😐", label: "Oké" },
  { e: "🙂", label: "Redelijk" },
  { e: "😊", label: "Goed" },
  { e: "😃", label: "Heel goed" },
  { e: "🤩", label: "Geweldig" },
  { e: "🥳", label: "Perfect" },
];

export const STEP_NAMES = ["Ontevreden", "Niet tevreden", "Neutraal", "Tevreden", "Zeer tevreden"];
